/**
 * PASTORAL_ARCHETYPE
 *
 * The "Ground Truth" statistical profile for Pastoral / Gentle Orchestral genres.
 * Features:
 * - Moderate Harmonic Rhythm (1 chord/bar).
 * - High Consonance (Pentatonic/Major).
 * - "Warm" Voice Distribution (Mid-heavy).
 * - Gentle Dynamics.
 */

import { BASE_ARCHETYPE } from './BaseArchetype.js';

export const PASTORAL_ARCHETYPE = {
    ...BASE_ARCHETYPE,

    // Harmonic Rhythm: Moderate flow.
    harmonicRhythm: {
        ...BASE_ARCHETYPE.harmonicRhythm,
        target: 1.0,
        tolerance: 0.5
    },

    // Voice Distribution: Focused on Woodwinds/Strings (Mid/High).
    // Less Bass heavy than Cinematic.
    voiceDistribution: {
        ...BASE_ARCHETYPE.voiceDistribution,
        low: 0.20,
        mid: 0.40,
        high: 0.40,
        tolerance: 0.15,
        tuttiThreshold: 0.8
    },

    // Dynamic Range: Gentle swells.
    dynamicRange: {
        ...BASE_ARCHETYPE.dynamicRange,
        minVariance: 0.10,
        targetVariance: 0.20,
        dynamicShape: 'swell'
    },

    // Interval Entropy: Very lyrical and smooth.
    intervalEntropy: {
        ...BASE_ARCHETYPE.intervalEntropy,
        stepRatio: 0.70,
        tolerance: 0.15
    }
};
